import { createSlice } from "@reduxjs/toolkit";

const helpdialog=createSlice({
	name:"helpdialogshow",
	initialState:{checkShow:false},
	reducers:{
		setCheckShow:(state,action)=>{state.checkShow=action.payload}
	}
});
export const {setCheckShow}=helpdialog.actions
export default helpdialog.reducer